import { SvgIcon } from '@mui/material';

interface DriverWeightIconProps {
  style?: React.CSSProperties;
}

export default function DriverWeightIcon({ style = {}, ...props }: DriverWeightIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 11.52 12.06" style={{ height: `14px`, ...style }}>
      <g>
        <path
          fill="#717679"
          d="M9.34,4.17c-.18-.51-.65-.96-1.19-.96h-.76c.17-.3,.28-.63,.28-1C7.66,1.1,6.77,.21,5.66,.21s-2,.9-2,2c0,.37,.11,.7,.28,1h-.81c-.54,0-1.14,.43-1.25,.96L.42,10.89c0,.53,.43,.96,.97,.96H10.13c.54,0,.97-.43,.97-.96l-1.76-6.72Zm-4.67-1.96c0-.55,.45-1,1-1s1,.45,1,1-.45,1-1,1-1-.45-1-1ZM1.45,10.85l1.41-6.48c.04-.07,.19-.17,.27-.17h5.02s.17,.11,.24,.27l1.67,6.38H1.45Z"
        />
      </g>
    </SvgIcon>
  );
}
